import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import { ReactComponent as AiLogo } from "../../../../Assets/img/icons/ai-rewrite-logo.svg";

 const TextInputModal = ({
    visible,
    title,
    message,
    placeholder,
    confirmButtonText,
    confirmButtonColor,
    cancelButtonText,
    confirmButtonTextColor,
    cancelButtonColor,
    inputText,
    setInputText,
    onConfirmPress,
    onCancelPress,
    onClosePress,
    generateAIRemark
  }) => (
    <Dialog open={visible} onClose={onClosePress} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {message}
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          placeholder={placeholder}
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            mb: 2,
          }}
          onClick={generateAIRemark}
        >
          {/* <SmartToyIcon sx={{ color: '#00E9E7', mr: 1 }} /> */}
          {/* <Typography sx={{ color: "black" }}>Generate with AI</Typography> */}
            <Button
                              variant="outlined"
                              sx={{ color: "#0044C6" }}
                              className="ai-rewrite-button"
                              onClick={generateAIRemark}
                             
                              startIcon={<AiLogo />}
                            >
                              Generate
                            </Button>
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button
          onClick={onCancelPress}
          // sx={{
          //   backgroundColor: cancelButtonColor,
          //   "&:hover": {
          //     backgroundColor: cancelButtonColor,
          //   },
          // }}
        >
          {cancelButtonText}
        </Button>
        <Button
          onClick={onConfirmPress}
          variant="contained"
          sx={{
            backgroundColor: confirmButtonColor,
            color: confirmButtonTextColor,
            "&:hover": {
              backgroundColor: confirmButtonColor,
            },
          }}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );


  export default TextInputModal